"use strict";

exports.__esModule = true;
exports.pxToRem = pxToRem;
var BASE_FONT = 16;

function pxToRem(size) {
  return size / BASE_FONT + "rem";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/utils/styles.js
// module id = 26
// module chunks = 0